import { render, staticRenderFns } from "./DataListActes.vue?vue&type=template&id=3146b39b&scoped=true&"
import script from "./DataListActes.vue?vue&type=script&lang=js&"
export * from "./DataListActes.vue?vue&type=script&lang=js&"
import style0 from "./DataListActes.vue?vue&type=style&index=0&id=3146b39b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3146b39b",
  null
  
)

export default component.exports